import React from "react";
import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";

const RadioFormSimple = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  value,
  options,
  handleChange,
}) => {
  if (!options || !Array.isArray(options)) {
    return null;
  }

  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        width: "100%",
      }}
    >
      <FormControl
        sx={{}}
        error={Boolean(orderFormFieldTouched && orderFormFieldError)}
      >
        <RadioGroup
          aria-labelledby={`${orderFormFieldKey}-label`}
          value={value}
          name={orderFormFieldKey}
          onChange={handleChange}
        >
          {options.map(({ key, name }, index) => {
            return (
              <FormControlLabel
                key={key || `option-${index}`}
                value={key || `option-${index}`}
                control={<Radio />}
                label={name || ""}
              />
            );
          })}
        </RadioGroup>
        <FormHelperText>
          {" "}
          {orderFormFieldTouched && orderFormFieldError
            ? orderFormFieldError
            : " "}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default RadioFormSimple;
